// eslint-disable-next-line import/no-anonymous-default-export
export default {
  about: 'O TOP3',
  appName: 'TOP3',
  data: 'Dane',
  tasks: 'Zadania',
  'tasks.create_title': 'Utwórz nowe zadanie',
  'task.removed': 'Zadanie zostało usunięte',
  logout: 'Wyloguj',
  password: 'Hasło',
  email: 'E-mail',
  login: 'Zaloguj Się',
  loginError: 'E-mail lub hasło było niepoprawne',
  pleaseWait: 'Proszę czekać...',
  loggedOut: 'Wylogujesz się z systemu!',
  monday: 'Poniedziałek',
  tuesday: 'Wtorek',
  wednesday: 'Środa',
  thursday: 'Czwartek',
  friday: 'Piątek',
  saturday: 'Sobota',
  sunday: 'Niedziela',
  header: 'Zadanie',
  type: 'Rodzaj',
  typeActivity: 'Czynność',
  typeBoard: 'Personel / zarząd',
  typeDevelopment: 'Rozwój strategiczny',
  task: 'Zadanie',
  plannedResult: 'Cel',
  achievedResult: 'Wynik',
  rating: 'Ocena',
  ratingMet: 'Zadowalający',
  ratingNotMet: 'Niedostateczny',
  ratingAverage: 'Średni',
  save: 'Zapisać',
  cancel: 'Anuluj',
  date: 'Data',
  weekday0: 'Poniedziałek',
  weekday1: 'Wtorek',
  weekday2: 'Środa',
  weekday3: 'Czwartek',
  weekday4: 'Piątek',
  weekday5: 'Sobota',
  weekday6: 'Niedziela',
  week: 'Tydzień',
  user: 'Pracownik',
  'user.filter': 'Przeszukaj pracownika ...',
  noResults: 'Nie znaleziono',
  comments: 'Komentarze',
  delete: 'Usunąć',
  confirmTaskDelete: 'Czy na pewno chcesz usunąć to zadanie?',
  myTasks: 'Moje zadania',
  sessionExpired: 'Sesja się skończyła, zaloguj się ponownie.',
  attachFile: 'Załącz plik',
  confirmCommentDelete: 'Czy na pewno chcesz usunąć ten komentarz?',
  commentEmail: 'Komentarz został wysłany pocztą elektroniczną',
  required: 'To pole jest wymagane',
  'comment.tooltip': 'Dodaj komentarz',
  'groups.title': 'Grupy',
  'group.title': 'Grupa',
  'groups.edit_title': 'Edytuj grupę',
  'groups.create_title': 'Stworzyć grupę',
  'groups.delete_title': 'Usuń grupę',
  'groups.id': 'Nie.',
  'groups.name': 'Nazwa',
  'groups.ownerId': 'Menedżer',
  'groups.changeOwner': 'Wybierz menedżera ...',
  'groups.find': 'Szukaj grupy ...',
  'group.members': 'Członkowie',
  'group.guests': 'Goście',
  'group.addMember': 'Dodaj członka',
  'group.addGuest': 'Dodaj gość',
  'group.noMembers': 'Nikt nie jest dodawany',
  'group.confirmDelete': 'Czy na pewno chcesz usunąć tę grupę?',
  'users.title': 'Użytkownicy',
  'user.title': 'Użytkownik',
  'user.profile': 'Mój profil',
  'user.modify.title': 'Edytuj użytkownika',
  'users.create.tooltip': 'Stwórz użytkownika',
  'users.delete_title': 'Usuń użytkownika',
  'user.created': 'Naudotojas sukurtas',
  'user.updated': 'Naudotojas pakeistas',
  'user.removed': 'Naudotojas pašalintas',
  'users.id': 'Nie.',
  'user.name': 'Nazwa',
  'user.surname': 'Nazwisko',
  'user.role': 'Rola',
  'user.role.ADMIN': 'Administrator',
  'user.role.USER': 'Użytkownik',
  'user.role.undefined': 'Niezdefiniowany',
  'user.email': 'E-mail',
  'user.email.unique': 'Email musi być unikalny',
  'user.username': 'Nazwa Użytkownika',
  'user.username.unique': 'Nazwa użytkownika musi być unikalna',
  'user.password': 'Hasło użytkownika',
  'user.members': 'Członek w grupach',
  'user.guests': 'Gość w grupach',
  'user.addGroup': 'Dodaj grupę',
  'user.noMembers': 'Nikt nie jest dodawany',
  'user.delete.confirm': 'Czy na pewno chcesz usunąć tego użytkownika?',
  'user.language.select': 'Język',
  'user.language.EN': 'English',
  'user.language.ES': 'Ispano',
  'user.language.PL': 'Polskie',
  'user.language.RU': 'Русский',
  'user.language.LT': 'Lietuvių',
  'user.language.LV': 'Latviešu',
  'user.language.EE': 'Eesti',
  'user.view.edit': 'Redaguoti naudotoją',
  'user.role.select': 'Rolė',
  'user.save.tooltip': 'Išsaugoti naudotoją',
  'user.cancel.modify.tooltip': 'Atšaukti',
  'user.password.change.save.tooltip': 'Išsaugoti naują slaptažodį',
  'user.password.change.cancel.tooltip': 'Atšaukti',
  'user.view.change.password': 'Zmień hasło',
  'user.password.change.title': 'Zmiana hasła',
  'user.password.old': 'Stare hasło',
  'user.password.new1': 'Nowe hasło',
  'user.password.new2': 'Powtórz nowe hasło',
  'user.password.change.mismatch': 'Hasła nie pasują',
  'about.title': 'O TOP3',
  'about.tagline': 'Naciśnięcie tego przycisku spowoduje pobranie opisu systemu TOP3',
  'about.action': 'Pobieranie',
  'about.text': 'Będziemy czekać na pytania i obserwacje naszego systemu '
    + '<a href="mailto:pagalba@axis.lt">pagalba@axis.lt</a> .',
  'user.password.changed': 'Hasło zostało zmienione.',
  'user.password.change.failed': 'Nie można zmienić hasła. Biorąc pod uwagę hasło było niewłaściwe',
  dashboard: 'Grafikas',
  'dashboard.generate': 'Generuoti',
  'dashboard.saveAsImage': 'Siųstis',
  'dashboard.exportToExcel': 'Exportuoti į Excel',
  'dashboard.dataZoom': 'Priartinti',
  'dashboard.dataZoomReset': 'Gražinti praeitą vaizdą',
  'dashboard.restore': 'Atstatyti pradinį vaizdą',
  'dashboard.noData': 'Nėra duomenų',
  'dashboard.data.title': 'Grafikas',
  'dashboard.data.dateFrom': 'Laikotarpis nuo (imtinai)',
  'dashboard.data.dateTo': 'Laikotarpis iki (imtinai)',
  'dashboard.data.unit': 'Matavimo vienetas',
  'dashboard.data.unit.WEIGHT': 'Svoris, t',
  'dashboard.data.unit.VOLUME': 'Tūris, m3',
  'dashboard.data.unit.VOLUME_AT_15C': 'Tūris prie 15°C, m3',
  'dashboard.data.exportToExcel': 'Excel',
  'dashboard.data.reportdate': 'Laikas',
  'dashboard.data.official': 'Buhalterija',
  'dashboard.data.fact': 'Faktinis',
  'dashboard.data.factFrom': 'Faktinis nuo',
  'dashboard.data.factTo': 'Faktinis iki',
  'dashboard.data.factPart5': 'Talpykla5',
  'dashboard.data.factPart6': 'Talpykla6',
  'dashboard.data.diff': 'Skirtumas',
  'dashboard.data.counter': 'Skaitiklis',
  'dashboard.data.counterDiff': 'Skaitiklio skirtumas',
  // product form generic
  products: 'Produktai',
  'products.title': 'Produktai',
  'product.title': 'Produktas',
  'product.delete.confirm': 'Ar tikrai norite pašalinti produktą',
  'product.updated': 'Produktas atnaujintas',
  'product.created': 'Produktas sukurtas',
  'product.filter': 'Ieškoti produkto...',
  'product.save.tooltip': 'Išsaugoti produktą',
  'product.modify.title': 'Produktas',
  'product.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'product.create.title': 'Produkto kūrimas',
  'product.cancel.create.tooltip': 'Atšaukti kūrimą',
  'product.create.tooltip': 'Kurti produktą',
  // product form specific
  'product.type': 'Produktas',
  'product.description': 'Aprašymas',
  'product.shortDescription': 'Trumpas aprašymas',
  'product.classificator': 'Klasifikatorius',
  'product.tarrifGroupCode': 'Tarifinė grupė',
  'product.materialType': 'Produkto rūšis',
  'product.name.unique': 'Produkto pavadinimas turi būti unikalus',

  // driver form generic
  drivers: 'Vairuotojai',
  'drivers.title': 'Vairuotojai',
  'driver.title': 'Vairuotojas',
  'driver.create.tooltip': 'Kurti Vairuotoją',
  'driver.updated': 'Vairuotojas atnaujintas',
  'driver.created': 'Vairuotojas sukurtas',
  'driver.removed': 'Vairuotojas pašalintas',
  'driver.filter': 'Ieškoti vairuotojo...',
  'driver.save.tooltip': 'Išsaugoti vairuotoją',
  'driver.modify.title': 'Vairuotojo redagavimas',
  'driver.create.title': 'Vairuotojo kūrimas',
  'driver.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'driver.cancel.create.tooltip': 'Atšaukti kūrimą',
  'driver.delete.confirm': 'Ar tikrai norite pašalinti vairuotoją',
  // driver form specific
  'driver.fullName': 'Vairuotojo vardas pavardė',
  'driver.adrNo': 'Vairuotojo ADR numeris',
  'driver.adrDate': 'Vairuotojo ADR galiojimo data',

  // company form generic
  companies: 'Įmonės',
  'companies.title': 'Įmonės',
  'company.title': 'Įmonė',
  'company.create.tooltip': 'Kurti Įmonę',
  'company.updated': 'Įmonė atnaujinta',
  'company.created': 'Įmonė sukurta',
  'company.removed': 'Įmonė pašalinta',
  'company.filter': 'Ieškoti įmonės ...',
  'company.save.tooltip': 'Išsaugoti įmonę',
  'company.modify.title': 'Įmonės redagavimas',
  'company.create.title': 'Įmonės kūrimas',
  'company.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'company.cancel.create.tooltip': 'Atšaukti kūrimą',
  'company.delete.confirm': 'Ar tikrai norite pašalinti įmonę ?',
  // company form specific
  'company.name': 'Pavadinimas',
  'company.address': 'Adresas',
  'company.vatCode': 'PVM kodas',
  'company.country': 'Valstybė',
  'company.companyCode': 'Įmonės kodas',
  'company.exciseWhNo': 'Akcizinio sandėlio Nr.',
  'company.additionalInformation': 'Papildoma informacija',
  'company.companyCode.unique': 'Įmonės kodas turi būti unikalus',
  'company.code.unique': 'Įmonės kodas turi būti unikalus',
  'country.select': 'Valstybė',
  'company.whClient': 'Sandėlio klientas',

  // tank form generic
  tanks: 'Talpyklos',
  'tanks.title': 'Talpyklos',
  'tank.create.tooltip': 'Sukurti talpyklą',
  'tank.updated': 'Talpykla atnaujinta',
  'tank.created': 'Talpykla sukurta',
  'tank.removed': 'Talpykla pašalinta',
  'tank.filter': 'Ieškoti talpyklos...',
  'tank.save.tooltip': 'Išsaugoti talpyklą',
  'tank.modify.title': 'Talpyklos redagavimas',
  'tank.create.title': 'Talpyklos kūrimas',
  'tank.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'tank.cancel.create.tooltip': 'Atšaukti kūrimą',
  'tank.delete.confirm': 'Ar tikrai norite pašalinti talpyklą ?',
  // tank form specific
  'tank.name': 'Talpyklos pavadinimas',
  'tank.capacity.ltr': 'Talpa litrais (l)',
  'tank.capacity.kg': 'Talpa kilogramais (kg)',
  'tank.material': 'Produktas',
  'tank.name.unique': 'Talpyklos pavadinimas turi būti unikalus',
  'material.select': 'Produktas',

  // transport form generic
  transports: 'Transporto priemonės',
  'transports.title': 'Transporto priemonės',
  'transport.title': 'Transporto priemonė',
  'transport.create.tooltip': 'Kurti Transporto priemonę',
  'transport.updated': 'transporto priemonė atnaujinta',
  'transport.created': 'Transporto priemonė sukurta',
  'transport.removed': 'Transporto priemonė pašalinta',
  'transport.filter': 'Ieškoti transporto priemonės',
  'transport.save.tooltip': 'Saugoti transporto priemonę',
  'transport.edit.title': 'Transporto priemonės redagavimas',
  'transport.create.title': 'Transporto priemonės kūrimas',
  'transport.cancel.modify.tooltip': 'Atšaukti',
  'transport.delete.confirm': 'Ar tikrai norite pašalinti transporto priemonę',
  // transport form specific
  'transportType.select': 'Tipas',
  'transport.name.unique': 'Transporto priemonės numeris turi būti unikalus',
  'transports.description': 'Apibūdinimas',
  'transports.brand': 'Markė',
  'transports.model': 'Modelis',
  'transports.adrNo': 'ADR numeris',
  'transports.adrDate': 'ADR galiojimo data',
  'transports.segments': 'Segmentų talpos',
  'transports.segmentNo': 'Segmento Nr.',
  'transports.capacityLtr': 'Segmento talpa, l',
  'transport.segment.add': 'Pridėti segmentą',
  'transport.segment.remove': 'Pašalinti segmentą',
  'transport.identificationNo': 'Numeris',
};
